import styled from "styled-components"

export const MapCardStyle = styled.div`
  padding: 40px;
  max-width: 450px;
  min-height: 372px;
  box-sizing: border-box;
  border-radius: 40px;
  cursor: pointer;
  background-color: ${(props) => props.theme.historyCardGradient};
  border: 1px solid #282f47;
  box-shadow: 0px 4px 36px 0px rgba(0, 0, 0, 0.25);
  opacity: 1;
  @media (max-width: 1115px) {
    width: 100%;
    scroll-snap-align: start;
  }
  @media (max-width: 576px) {
    min-width: 335px;
    min-height: 330px;
    border-radius: 25px;
    padding: 40px 28px 22px 28px;
    box-shadow: none;
  }
  @media (max-width: 370px) {
    min-height: 300px;
    padding: 20px 18px;
  }
  &:hover {
    background-color: #141d31;
  }
`

export const Title = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  ${(props) => props.theme.typography.heroHeadline2}
  font-size: 22px;
  font-weight: 600;
  line-height: 170%;
  color: ${(props) => props.theme.base};
  @media (max-width: 576px) {
    font-size: 20px;
    font-weight: 600;
  }
`

export const Description = styled.div`
  ${(props) => props.theme.typography.descriptionMsg}
  color: ${(props) => props.theme.whiteAlpha60};
  margin-top: 10px;
  margin-bottom: 20px;
  line-height: 170%;
  @media (max-width: 576px) {
    height: auto;
    font-size: 12px;
  }
  @media (max-width: 370px) {
    white-space: normal;
  }
`

export const SpecificDetails = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 20px;
  margin-top: 18px;
  .location-div {
    display: flex;
    flex-direction: column;
  }
  @media (max-width: 576px) {
    gap: 10px;
    margin-top: 20px;
    img {
      width: 18px;
      height: 18px;
    }
  }
`

export const DetailsText = styled.div`
  ${(props) => props.theme.typography.paragraph1}
  color: #FFFFFF99;
  @media (max-width: 576px) {
    font-size: 12px;
    line-height: normal;
  }
`
